import "../../css/app.css";
import { atom, useAtom } from "jotai";
import * as React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';

const valueAtom = atom("");

export default function HardwareDialog(props) {
    const { id, name, onClose, value: valueProp, open, option, ...other } = props;
    const [value, setValue] = useAtom(valueAtom);
    const [searchTerm, setSearchTerm] = React.useState("");

    if (value === "" || value === null) {
        setValue([{ dialogId: id, value: valueProp }]);
    }
    const radioGroupRef = React.useRef(null);
    const handleEntering = () => {
        if (radioGroupRef.current != null) {
            radioGroupRef.current.focus();
        }
    };

    const handleCancel = () => {
        onClose();
    };

    const handleChange = (event) => {
        const newValue = Array.isArray(value) ? value.map((el) => {
            if (el.dialogId === id) {
                return { ...el, value: event.target.value }
            }
            else {
                return { ...el, dialogId: id, value: event.target.value }
            }
        }) : null
        setValue(newValue);
        onClose(event.target.value, id);
    };

    const handleInput = (event) => {
        setSearchTerm(event.target.value);
    }

    return (
        <Dialog
            sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
            maxWidth="xs"
            TransitionProps={{ onEntering: handleEntering }}
            open={open}
            {...other}
            style={{ overflow: "hidden" }}
        >

            <h3 id="hardware_dialog_header" style={{ paddingLeft: "10px" }}>{name}</h3>
            <span className="close_box" onClick={handleCancel}></span>
            <div className="modelSearch">
                <b style={{ display: "inline-block" }}> 絞り込み：</b>
                {
                    id === "hwNameText0" ? <input className="search" placeholder="本体（モデル名）を検索..." onChange={handleInput} /> : null
                }
                {
                    id === "swNameText0" ? <input className="search" placeholder="OS名を検索..." onChange={handleInput} /> : null
                }
                {
                    id === "hwNameText1" || id === "hwNameText2" ? <input className="search" placeholder="ハードウェア名を検索..." onChange={handleInput} /> : null
                }
                {
                    id === "swNameText1" ? <input className="search" placeholder="ソフトウェア名を検索..." onChange={handleInput} /> : null
                }
            </div>
            <div className="mod-input-radio" style={{
                borderTop: "1px solid rgba(0, 0, 0, 0.12)",
                padding: "16px 24px",
                marginBottom: "0px",
                overflowX: "auto"
            }}>
                <ul className="list" style={{ display: "grid", marginTop: "0px" }}>
                    {
                        option
                            .filter((option) => {
                                if (option.toLowerCase().includes(searchTerm.toLowerCase())) {
                                    return option
                                } else { return "" }
                            })
                            .map((option, index) => (
                                <li key={index} style={{
                                    padding: "0px 0 0 42px",
                                    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                    fontSize: "1rem",
                                }}>
                                    <label >
                                        <input type="radio" id={`${option}-${index}`} checked={option === valueProp} value={option} onChange={handleChange} />
                                        <span
                                            className="label-dialog" style={{ fontSize: "20px", cursor: "pointer" }}>{option}</span>
                                    </label>
                                </li>
                            ))}
                </ul>
            </div>
        </Dialog >
    );
}

HardwareDialog.propTypes = {
    id: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    option: PropTypes.array.isRequired,
};